import FaqResultsContent from './faq-results-content';

export default FaqResultsContent;
